module.exports = __webpack_public_path__ + "static/media/klickly-logo-small.10bd8cda.svg";